interface PullQuoteProps {
  quote: string;
  cite?: string;
}

/**
 * 引用帯。本文中の象徴的な一節を大きく引き立てる。紙色地＋金の大引用符。
 */
export default function PullQuote({ quote, cite }: PullQuoteProps) {
  return (
    <figure className="relative bg-[#f6f3ec] border-y border-[#e2ddd2] px-6 py-12 sm:py-14">
      <div className="max-w-3xl mx-auto relative">
        <span aria-hidden="true" className="absolute -top-8 -left-2 font-['Playfair_Display',serif] text-[#a38e65]/40 text-[72px] leading-none select-none">&ldquo;</span>
        <blockquote className="jba-display text-[#1a2942] text-xl sm:text-2xl lg:text-[26px] leading-[1.75] tracking-[0.01em] relative z-10">
          {quote}
        </blockquote>
        {cite && (
          <figcaption className="mt-5 font-['Playfair_Display',serif] italic text-[#8f7a56] text-sm">— {cite}</figcaption>
        )}
      </div>
    </figure>
  );
}
